// filepath: apps/web/src/features/directory/teams/TeamsPage.tsx
//
// FR-UI-DIR-1 AC-7 — teams page.
//
// F1 FINDING: `/api/directory/teams` is NOT shipped yet. Per the
// impact analysis, this page MUST render the fetch-failure state
// immediately and MUST NOT call the missing endpoint. The static-
// guard test in apps/web/src/runtime/staticGuards.test.ts asserts no
// fetch call to /api/directory/teams and no import of that route.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

export function TeamsPage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <section className="directory-teams" data-testid="teams-page">
      <header className="directory-teams__header">
        <h1>{t("directory.teams.title", "Teams")}</h1>
      </header>
      <p
        role="alert"
        className="directory-teams__fetch-failure"
        data-testid="teams-fetch-failure"
      >
        {t("directory.teams.deferred.body")}
      </p>
    </section>
  );
}
